<template>
  <a-modal
    v-model="visible"
    :footer="null"
    class="information"
    :mask="false"
    width="100%"
    :closable="false"
    wrapClassName="fullModal"
  >
    <div class="info-wrap">
      <div class="left-menu">
        <h1 class="bor-bottom">个人账户</h1>
        <ul class="tabs">
          <li :class="{'cur': current === 1}" @click="current=1"><span class="ver-mid"><sass-icon type="hi-wodexinxi" style="font-size: 24px;" /></span><span class="ml15">我的信息</span></li>
          <!-- <li :class="{'cur': current === 2}" @click="current=2"><span class="ver-mid"><sass-icon type="hi-zhanghaomima" style="font-size: 24px;" /></span><span class="ml15">账号密码</span></li> -->
          <li :class="{'cur': current === 3}" @click="current=3"><span class="ver-mid"><sass-icon type="hi-zhanghaomima" style="font-size: 24px;" /></span><span class="ml15">个人安全</span></li>
        </ul>
      </div>
      <div class="right-con">
        <div v-if="current === 1">
          <h1 class="bor-bottom">用户信息</h1>
          <div class="content">
            <div class="myInfo bor-bottom">
              <div class="logo">
                <avatar :size="104" :src="avatar" :bg-color="avatarBg" />
              </div>
              <div class="info-box ml85">
                <div class="item">
                  <p class="label">账号</p>
                  <div class="info-txt">{{ userInfo.code }}</div>
                </div>
                <div class="item">
                  <p class="label">用户名</p>
                  <div class="info-txt">{{ userInfo.name }}</div>
                </div>
                <div class="item">
                  <p class="label">手机号</p>
                  <div class="info-txt">{{ userInfo.mobile }}</div>
                </div>
                <div class="item">
                  <p class="label">邮箱地址</p>
                  <div class="info-txt">{{ userInfo.email }}</div>
                </div>
              </div>
            </div>
            <div class="title">员工信息</div>
            <!--  bor-bottom -->
            <div class="info-box">
              <div class="item w190">
                <p class="label">员工编码</p>
                <div class="info-txt">{{ userInfo.ecode }}</div>
              </div>
              <div class="item w190">
                <p class="label">员工姓名</p>
                <text-tooltip class="info-txt info-txt-max" :content="userInfo.ename" refName="ename" />
              </div>
              <div class="item w190">
                <p class="label">联系电话</p>
                <div class="info-txt">{{ userInfo.emobile }}</div>
              </div>
              <div class="item w190">
                <p class="label">员工工号</p>
                <div class="info-txt">{{ userInfo.employeeNo }}</div>
              </div>
              <div class="item w190">
                <p class="label">任职部门</p>
                <div class="info-txt">{{ userInfo.departName }}</div>
              </div>
              <div class="item w190">
                <p class="label">任职岗位</p>
                <div class="info-txt">{{ userInfo.jobName }}</div>
              </div>
              <div class="item w190">
                <p class="label">所属公司</p>
                <div class="info-txt">{{ userInfo.company }}</div>
              </div>
              <div class="item w190">
                <p class="label">成本中心</p>
                <div class="info-txt">{{ userInfo.costCenterName }}</div>
              </div>
              <div class="item w190">
                <p class="label">上级汇报人</p>
                <div class="info-txt">{{ userInfo.superiorReporterName }}</div>
              </div>
              <div class="item w190">
                <p class="label">性别</p>
                <div class="info-txt">{{ userInfo.sex && (userInfo.sex === 'MALE' ? '男' : '女') }}</div>
              </div>
            </div>
            <!-- <div class="title">兼职信息</div>
            <div class="info-box">
              <div class="item w190">
                <p class="label">兼职部门</p>
                <div class="info-txt" v-for="(item, index) in userInfo.departs" :key="index">{{ item.departName }}</div>
              </div>
              <div class="item w190">
                <p class="label">兼职岗位</p>
                <div class="info-txt" v-for="(item, index) in userInfo.departs" :key="index">{{ item.jobName }}</div>
              </div>
            </div> -->
          </div>
        </div>
        <div v-if="current === 2">
          <h1 class="bor-bottom">账号密码</h1>
          <div class="passwords">
            <div class="title">手机号码</div>
            <div><span>手机号码</span><a-input disabled :value="mobile" class="ipt-01"/></div>
            <div class="h28 bor-bottom"></div>
            <div class="title">密码重置</div>
            <a-form class="set-password" :form="setPasswordForm" @submit="handleSubmit">
              <a-form-item label="输入原密码" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <div class="input-area set-password-step1">
                  <!-- <span class="required-mark">*</span> -->
                  <a-input
                    v-decorator="[
                      'oldPassword',
                      {
                        rules: [
                          { required: true, message: '请输入原密码' }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    size="large"
                    :type="showOrigin ? 'text' : 'password'"
                    placeholder="密码长度在6-20个字符之间"
                  >
                    <a-button slot="suffix" type="link" @click="showOrigin = !showOrigin">
                      <sass-icon :type="showOrigin ?'_xianshimima' : '_yincangmima'" style="font-size: 16px;" />
                    </a-button>
                  </a-input>
                </div>
              </a-form-item>
              <a-form-item label="输入新密码" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <div class="input-area set-password-step2">
                  <!-- <span class="required-mark">*</span> -->
                  <a-input
                    v-decorator="[
                      'newPassword',
                      {
                        rules: [
                          { required: true, message: '请输入新密码' },
                          { validator: newPswValidator }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    size="large"
                    :type="showNew ? 'text' : 'password'"
                    placeholder="密码长度在6-20个字符之间"
                    @change="errMsg = ''"
                  >
                    <a-button slot="suffix" type="link" @click="showNew = !showNew">
                      <sass-icon :type="showNew ?'_xianshimima' : '_yincangmima'" style="font-size: 16px;" />
                    </a-button>
                  </a-input>
                </div>
              </a-form-item>
              <a-form-item label="确认新密码" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <div class="input-area set-password-step2">
                  <!-- <span class="required-mark">*</span> -->
                  <a-input
                    v-decorator="[
                      'newPassword1',
                      {
                        rules: [
                          { required: true, message: '请确认新密码' },
                          { validator: confirmPswValidator }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    size="large"
                    :type="showRe ? 'text' : 'password'"
                    placeholder="密码长度在6-20个字符之间"
                    @change="errMsg = ''"
                  >
                    <a-button slot="suffix" type="link" @click="showRe = !showRe">
                      <sass-icon :type="showRe ?'_xianshimima' : '_yincangmima'" style="font-size: 16px;" />
                    </a-button>
                  </a-input>
                </div>
                <p v-show="errMsg" class="err-msg">{{ errMsg }}</p>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" block htmlType="submit" class="submit-btn" size="large">确定</a-button>
              </a-form-item>
            </a-form>
          </div>
        </div>
        <div v-if="current === 3">
          <lc-account-secure
            ref="lcAccountSecureRef"
            class="lc-account-secure"
            :cardItem="cardItem"
            @change="onChange" />
        </div>
      </div>
    </div>
    <a-button type="button" class="close-btn" @click="doCancle">
      <sass-icon type="hi-guanbidanchuangdanchuang" style="font-size: 13px;" />
    </a-button>
  </a-modal>
</template>
<script>
import CommonIcon from '@/components/common-icon'
import TextTooltip from '@/components/TextTooltip'
import { mapGetters, mapActions } from 'vuex'
import Avatar from '@/components/Avatar'
import { modifyPassword, getUserInfo } from '@/api/login'
import { Base64 } from 'js-base64'
import { isSerialNumber, sameChar } from '@/utils/util'
export default {
  name: 'Infomation',
  components: {
    CommonIcon,
    Avatar,
    TextTooltip
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      current: 1,
      setPasswordForm: this.$form.createForm(this),
      showOrigin: false,
      showNew: false,
      showRe: false,
      passwrod: '',
      errMsg: '',
      userInfo: {},
      cardItem: [
        {
          name: 'password',
          title: '登录密码',
          desc: '安全性高的密码可以使账户更安全，建议设置⼀个包含数字，符号及英文⼤⼩写的密码',
          isProcessBar: true,
          processBarAttr: { width: '100%', level: 2 },
          isAttestation: true
        },
        {
          name: 'phone',
          title: '手机绑定',
          desc: '您已经绑定了手机168****9888作为安全手机，可以找回密码和登录',
          isProcessBar: false,
          isAttestation: true
        },
        {
          name: 'email',
          title: '邮箱绑定',
          desc: '您还未设置邮箱作为您的安全邮箱，安全邮箱可以找回密码和登录。',
          isProcessBar: false,
          isAttestation: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['userId', 'avatar', 'avatarBg', 'nickname', 'roles', 'mobile']),
    visible: {
      get () {
        return this.isVisible
      },
      set () {}
    }
  },
  created () {
    this.getUserInfo()
  },
  methods: {
    ...mapActions(['ClearToken']),
    getUserInfo() {
      const id = this.userId
      getUserInfo({ id: id }).then(res => {
        if (res.code === '0' && res.data) {
          this.userInfo = res.data
          if (res.data.employeeId) {
            this.userInfo.departs = res.data.employeeInfo.departs
            this.userInfo.departName = res.data.employeeInfo.mainDepart.departName
            this.userInfo.jobName = res.data.employeeInfo.mainDepart.jobName
            this.userInfo.costCenterName = res.data.employeeInfo.costCenter.costCenterName
            this.userInfo.ecode = res.data.employeeInfo.code
            this.userInfo.ename = res.data.employeeInfo.name
            this.userInfo.emobile = res.data.employeeInfo.mobile
            this.userInfo.sex = res.data.employeeInfo.sex
            this.userInfo.employeeNo = res.data.employeeInfo.employeeNo
            this.userInfo.company = res.data.employeeInfo.company
            this.userInfo.superiorReporterName = res.data.employeeInfo.superiorReporters?.map(item => item.name).join('，')
          }
        }
      }).catch(err => {
        this.$notification.error({
          message: '错误',
          description: err.msg || '请求失败，请重试',
          duration: 2
        })
      })
    },
    newPswValidator(rule, value, callback) {
      const {
        mobile,
        userInfo: { accountCode }
      } = this
      if (!value) {
        callback(Error('请输入新密码'))
      } else if (value.length < 6 || value.length > 20) {
        callback(Error('新密码长度需在6-20个字符之间'))
      } else if (escape(value).indexOf('%u') > -1) {
        callback(Error('密码不能包含中文'))
      } else if (isSerialNumber(value)) {
        callback(Error('密码不可使用连续数字'))
      } else if (sameChar(value)) {
        callback(Error('密码不可使用连续相同字符'))
      } else if (value === mobile || value === accountCode) {
        callback(Error('密码不可与账号、手机号、微信号、邮箱相同'))
      } else {
        this.passwrod = value
        callback()
      }
    },
    confirmPswValidator(rule, value, callback) {
      if (!value) {
        callback(Error('请输入确认新密码'))
      } else if (this.passwrod && this.passwrod !== value) {
        callback(Error('两次输入的密码不一致'))
      }
      callback()
    },
    handleSubmit(e) {
      e.preventDefault()
      const { setPasswordForm } = this
      setPasswordForm.validateFields((err, values) => {
        if (!err) {
          const data = {
            accountId: this.$store.getters.userInfo.accountId
            // TODO 临时数据，后期需要删除
          }
          delete values.newPassword1
          for (const key in values) {
            data[key] = Base64.encode(values[key])
          }
          modifyPassword(data)
            .then(() => {
              this.$notification.success({
                message: '成功',
                description: '密码重置成功, 请重新登录',
                duration: 2
              })
              this.setPasswordForm.resetFields()
              setTimeout(() => {
                this.ClearToken({ toLogin: true })
              }, 1500)
            })
            .catch(err => {
              if (err.code && err.msg) {
                const {
                  setPasswordForm: { getFieldsValue, setFields }
                } = this
                const { code, msg, invalidField } = err
                const values = getFieldsValue()
                if (invalidField) {
                  setFields({
                    [invalidField]: {
                      value: values[invalidField],
                      errors: [
                        {
                          field: invalidField,
                          message: msg
                        }
                      ]
                    }
                  })
                } else {
                  switch (code) {
                    case 'AUTHEN0011':
                    case 'AUTHEN0004':
                      setFields({
                        oldPassword: {
                          value: values.oldPassword,
                          errors: [
                            {
                              field: 'oldPassword',
                              message: msg
                            }
                          ]
                        }
                      })
                      break
                    case 'AUTHEN0012':
                    case 'AUTHEN0014':
                      setFields({
                        newPassword: {
                          value: values.newPassword,
                          errors: [
                            {
                              field: 'newPassword',
                              message: msg
                            }
                          ]
                        },
                        newPassword1: {
                          value: values.newPassword1,
                          errors: [
                            {
                              field: 'newPassword1',
                              message: msg
                            }
                          ]
                        }
                      })
                      break
                    default:
                      this.errMsg = msg
                      break
                  }
                }
              } else {
                this.$notification.error({
                  message: '错误',
                  description: ((err.response || {}).data || {}).message || err.msg || '请求出现错误，请稍后再试',
                  duration: 4
                })
              }
            })
        }
      })
    },
    // 点击取消
    doCancle () {
      this.$emit('close', false)
    },
    onChange (e) {
      console.log(e, 'onChange修改完成后')
      this.ClearToken({ toLogin: true })
    }
  }
}
</script>
<style lang="less" scoped>
.info-wrap {
  display: flex;
  margin: 0 auto;
  padding-top: 50px;
  width: 1120px;
  justify-content: space-between;
}
.left-menu {
  border: 1px solid rgba(229, 229, 229, 1);
  border-radius: 4px;
  width: 256px;
  height: 163px;
  background: #fff;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, .06);
}
.right-con {
  overflow: hidden;
  border: 1px solid rgba(229, 229, 229, 1);
  border-radius: 4px;
  width: 840px;
  background: #fff;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, .06);
}
h1 {
  padding-left: 16px;
  height: 65px;
  font-family: 'PingFangSC-Medium';
  font-size: 18px;
  font-weight: 500;
  line-height: 65px;
  color: rgba(51, 51, 51, .85);
}
.bor-bottom {
  border-bottom: 1px solid rgba(159, 162, 169, .2);
}
.tabs li {
  position: relative;
  padding: 0 16px;
  height: 48px;
  font-size: 14px;
  line-height: 48px;
  vertical-align: middle;
  cursor: pointer;
  &.cur,&:hover {
    color: #00a497;
    background: #f6f7fb;
  }
  &.cur::before {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 48px;
    background: #00a497;
    content: '';
  }
}
.logo {
  padding: 0 20px;
}
.content {
  padding: 32px;
}
.passwords {
  padding: 0 32px 32px;
}
.myInfo {
  display: flex;
  justify-content: space-between;
}
.ml85 {
  margin-left: 85px;
}
.info-box {
  display: flex;
  flex: 1;
  // justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
  .item {
    margin-bottom: 24px;
    width: 170px;
    &.w190 {
      width: 190px;
    }
    .label {
      height: 20px;
      font-size: 14px;
      line-height: 20px;
      color: rgba(0, 0, 0, .45);
    }
    .info-txt {
      margin-top: 8px;
      height: 24px;
      font-family: 'PingFangSC-Medium';
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: rgba(51, 51, 51, .85);
    }
    .info-txt-max {
      width: 180px;
    }
  }
}
.title {
  position: relative;
  padding-left: 12px;
  height: 65px;
  font-family: 'PingFangSC-Medium';
  font-size: 16px;
  font-weight: 500;
  line-height: 65px;
  color: rgba(51, 51, 51, .85);
  &::before {
    display: inline-block;
    position: absolute;
    top: 26px;
    left: 0;
    width: 4px;
    height: 16px;
    background: #00a497;
    content: '';
  }
}
.ver-mid {
  vertical-align: -4px;
}
.ipt-01 {
  margin-left: 16px;
  width: 286px;
  height: 40px;
}
.set-password {
  margin: 0 auto;
  width: 370px;
  // .set-password-step1 {
  //   .ant-input-affix-wrapper .ant-input-suffix {
  //     right: 12px!important;
  //   }
  // }
  // .set-password-step2 {
  //   .ant-input-affix-wrapper .ant-input-suffix {
  //     right: 0px!important;
  //   }
  // }
}
.input-area {
  display: flex;
  align-items: center;
  & > input {
    flex: 1;
  }
}
.close-btn {
  position: absolute;
  top: 45px;
  right: 45px;
  border: 0;
  width: 45px;
  height: 45px !important;
  line-height: 42px;
  background: #e7e7e9;
}
.submit-btn {
  margin-left: 12px;
  width: 360px;
  height: 40px !important;
}
.h28 {
  height: 28px;
}
</style>
<style>
.passwords .ant-row.ant-form-item {
  height: 36px !important;
}
.passwords .ant-btn-link {
  color: rgba(51, 51, 51, .85);
}
.passwords .ant-input {
  border: 1px solid rgba(159, 162, 169, .20);
  padding-right: 0 !important;
  width: 280px;
  height: 36px !important;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  line-height: 36px;
  letter-spacing: 0;
}
.passwords .ant-input-affix-wrapper .ant-input-suffix {
  right: 0 !important;
}
.ant-input-affix-wrapper .ant-input-suffix {
  right: 12px;
}
.ant-form-item-with-help {
  margin-bottom: 24px;
}
.passwords .ant-form-item-control {
  line-height: 40px;
}
</style>
